export var Restriction;
(function (Restriction) {
    function convert(restriction) {
        return [value => value == restriction[0], `value: ${restriction[0]}`, restriction[1] ?? restriction[0].toString()];
    }
    Restriction.convert = convert;
})(Restriction || (Restriction = {}));
//# sourceMappingURL=Restriction.js.map